import {
  Alert,
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import InputAdornment from "@mui/material/InputAdornment";
import { loginWithEmail } from "../../actions/auth.js";
import { useEffect } from "react";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn, err ,data:user } = useSelector((state) => state.user);
  const label = { inputProps: { "aria-label": "Checkbox" } };

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(false);
  }, [isLoggedIn, err]);

  const [data, setData] = useState({ email: "", password: "" });
  const handleInputChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleLoginSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    dispatch(loginWithEmail(data)).then(() => {
      setLoading(false);
    });
  };

  return isLoggedIn ? (
    <Navigate to={user.role === "admin" ? "/transaction-list" : "/transaction-list"} replace="true" />
  ) : (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100vw"
      height="100vh"
      className="bkgColor"
    >
      <Paper elevation={3} sx={{ maxWidth: "500px", pt: 2 }}>
        <div className="logo-hold"></div>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={4}
          py={2}
        >
        </Box>
        {Boolean(err) ? <Alert severity="error">{err}</Alert> : <></>}
        <Box
          component="form"
          onSubmit={handleLoginSubmit}
          sx={{ px: 4, pb: 3 }}
          maxWidth={400}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                value={data.email}
                type="email"
                label="Email"
                onChange={handleInputChange}
                name="email"
                autoComplete="username"
                required
                fullWidth
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" className="iconColor">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                value={data.password}
                type="password"
                label="Password"
                onChange={handleInputChange}
                name="password"
                required
                autoComplete="current-password"
                fullWidth
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" className="iconColor">
                      <LockIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <Grid container className="justifyContent">
                <Button
                  variant="contained"
                  className="forgetPass"
                  color="secondary"
                  onClick={() => {
                    navigate("/forgot-password", { replace: true });
                  }}
                >
                  Forgot Password?
                </Button>
                {loading ? (
                  <div
                    style={{
                      width: "100%",

                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress></CircularProgress>
                  </div>
                ) : (
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    className="signInBtn"
                  >
                    Sign in
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
}
